import './target-correspondent.ajscss';

import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { IDirectoryService } from '@agent/core/search/directory.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { hasChange } from '@commons/util/helper/helper';
import { copy, IChangesObject, IComponentController, IComponentOptions, IPromise } from 'angular';

import { MediaType } from '@contact/upgrade';

import templateUrl from './target-correspondent.html';

const MODULE_NAME = 'transferTargetCorrespondent';

class TransferTargetCorrespondentCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public contactSkills: string[] = [];
  public eventTargetChange: Function;

  // internal properties
  public targetCorrespondent;

  constructor(
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    private readonly directoryService: IDirectoryService
  ) {}

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // contactSkills changed
    if (hasChange(changesObj['contactSkills'])) {
      this.contactSkills = copy(changesObj['contactSkills'].currentValue);
    }
  }

  getCorrespondents(text?: string): IPromise<any> {
    return this.directoryService
      .getExternalCorrespondents(
        this.sessionDeprecatedService.getProfile().domainId,
        this.agentConfigDeprecatedService.domainGroups,
        this.agentConfigDeprecatedService.agentTeam,
        this.contactSkills,
        text,
        [MediaType.MAIL]
      )
      .then(success =>
        success.data.map((external: any) => ({
          id: external.uuid,
          name: `${external.firstName} ${external.lastName}`,
          directoryName: external.directory.name + (external.category && external.category.name ? `../${external.category.name}` : ''),
          phoneNumber: external.phoneNumber,
          email: external.email,
        }))
      );
  }

  onTargetChange(): void {
    this.eventTargetChange({ $event: { target: this.targetCorrespondent } });
  }
}

export class TransferTargetCorrespondent implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    contactSkills: '<',
    eventTargetChange: '&',
  };
  controller = ['sessionDeprecatedService', 'agentConfigDeprecatedService', 'directory', TransferTargetCorrespondentCtrl];
}

export default MODULE_NAME;
